export default "__VITE_ASSET__B5DaL4nQ__"